var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 498.648 498.648",
    style: {
      enableBackground: "new 0 0 498.648 498.648"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 193.324,
    y: 330.648,
    style: {
      fill: "#00233F"
    },
    width: 112,
    height: 168
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C537A"
    },
    points: "311.564,275.824 468.428,329.416 491.492,498.648 256.492,498.648 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "311.564,275.824 432.676,341.088 460.756,498.648 256.492,498.648 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#037193"
    },
    points: "187.068,275.824 30.22,329.416 7.156,498.648 242.156,498.648 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C537A"
    },
    points: "167.476,373.344 30.22,329.416 7.156,498.648 242.156,498.648 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00233F"
    },
    points: "187.068,275.824 66.7,341.088 37.892,498.648 242.156,498.648  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M333.412,106.648c0,40.12-30.216,72-67.504,72H232.74c-37.28,0-67.504-31.88-67.504-72l0,0 c0-40.136,30.216-72,67.504-72h33.168C303.188,34.648,333.412,66.512,333.412,106.648L333.412,106.648z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "309.66,306.648 188.988,306.648 197.036,210.648 301.612,210.648 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "309.66,306.648 249.132,306.648 188.988,210.648 301.612,210.648 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M330.788,127.368c0,70.872-35.704,135-81.456,135c-45.768,0-81.488-64.128-81.488-135 c0-70.88,35.72-82.68,81.488-82.68C295.084,44.688,330.788,56.48,330.788,127.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M249.332,44.688c45.752,0,81.456,11.8,81.456,82.68c0,70.872-35.704,135-81.456,135"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8ECEF"
    },
    points: "247.348,450.128 175.236,352.264 149.188,282.472 185.892,267.096 249.332,307.248  312.756,267.096 349.444,282.472 323.412,352.264 251.3,450.128 249.268,453.584 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#C4CED6"
    },
    points: "249.332,307.248 312.756,267.096 349.444,282.472 323.412,352.264 251.3,450.128  249.268,453.584 247.348,450.128 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "185.892,267.096 249.132,306.648 175.252,346.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "312.756,267.096 249.132,306.648 323.412,346.36  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M168.316,116.624c-4.328-1.896-3.472-14.736,0.344-23.424c3.832-8.704,10.456-14.2,14.768-12.296 c4.344,1.904,7.936,12.784,0.936,19.192"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M330.3,116.44c4.344-1.912,3.528-14.744-0.28-23.432c-3.816-8.68-10.408-14.168-14.752-12.256 c-4.328,1.912-7.952,12.808-0.952,19.192"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M359.908,85.664c0,9.152-49.512,16.536-110.592,16.536S138.74,94.808,138.74,85.664 s49.504-2.6,110.576-2.6S359.908,76.52,359.908,85.664z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#037193"
    },
    d: "M249.316,0c-47.456,0-85.92,40.784-85.92,80.36c0,2.016,0.168,3.816,0.376,5.576 c23.184,8.264,53,5.248,85.544,5.248c32.56,0,62.376,3.016,85.56-5.248c0.184-1.768,0.36-3.56,0.36-5.576 C335.236,40.784,296.788,0,249.316,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C537A"
    },
    d: "M163.396,80.36c0,2.016,0.168,3.816,0.376,5.576c23.184,8.264,53,5.248,85.544,5.248 c32.56,0,62.376,3.016,85.56-5.248c0.184-1.768,0.36-3.56,0.36-5.576c0-39.576-38.456-80.36-85.92-80.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M249.316,99.184c32.56,0,62.376-4.984,85.56-13.248c0.184-1.768,0.36-3.56,0.36-5.576 c0-39.576-38.456-80.36-85.92-80.36"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M204.204,220.688c-0.2-0.224-0.312-0.376-0.312-0.376S203.972,220.528,204.204,220.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M249.324,197.872c-8-0.424-23.28,0.288-32.096,11.456c-9.344,11.8-12.2,11.912-13.064,11.36 c1.36,1.472,7.336,6.344,22.416-1.592c10.8-5.672,14.744-6.416,22.744-6.176V197.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M294.428,220.688c0.2-0.224,0.312-0.376,0.312-0.376S294.66,220.528,294.428,220.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M249.324,197.872c8-0.424,23.264,0.288,32.08,11.456c9.344,11.8,12.216,11.912,13.064,11.36 c-1.36,1.472-7.32,6.344-22.416-1.592c-10.784-5.672-14.728-6.416-22.728-6.176V197.872z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#158EAA"
    },
    d: "M249.316,75.688c-32.328,0-61.936,2.944-85.064-5.112c-0.504,3.256-0.856,6.52-0.856,9.784 c0,2.016,0.168,3.816,0.376,5.576c23.184,8.264,53,5.248,85.544,5.248c32.56,0,62.376,3.016,85.56-5.248 c0.184-1.768,0.36-3.56,0.36-5.576c0-3.256-0.352-6.52-0.856-9.776C311.252,78.632,281.644,75.688,249.316,75.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#037193"
    },
    d: "M249.316,91.184c32.56,0,62.376,3.016,85.56-5.248c0.184-1.768,0.36-3.56,0.36-5.576 c0-3.256-0.352-6.52-0.856-9.776c-23.128,8.048-52.736,5.104-85.064,5.104"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 248.22,
    cy: 471.688,
    r: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M313.516,97.496c0,0-6.248,18.704,2.488,29.936c0,0,2.496,1.248,3.128,6.856 c0.608,5.616,2.016,21.984-4.528,53.792c-2.16,10.536-16.048,39.152-33.512,29.168l-4.336,1.872c0,0,4.576,24.328-27.424,23.704 v21.832c0,0,32.408,3.112,54.856-28.072s24-75.464,23.368-100.416c-0.608-24.952,18.448-33.584,13.448-42.312 C336.02,85.136,313.516,97.496,313.516,97.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M182.908,97.496c0,0,6.24,18.704-2.496,29.936c0,0-2.496,1.248-3.112,6.856 c-0.632,5.616-2.032,21.984,4.512,53.792c2.168,10.536,16.048,39.152,33.512,29.168l5.464,1.872c0,0-3.472,24.328,28.528,23.704 v21.832c0,0-33.528,3.112-55.984-28.072s-24.544-75.464-23.92-100.416s-16.216-37.456-11.232-46.184 C163.164,81.264,182.908,97.496,182.908,97.496z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 167.812,
    cy: 122.808,
    r: 10.592
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M170.748,138.432c0.528,4.96-3.064,9.416-8.024,9.952c-4.936,0.528-9.416-3.064-9.944-8.016 c-0.528-4.968,3.072-9.416,8.024-9.944C165.772,129.888,170.212,133.472,170.748,138.432z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 158.548,
    cy: 153.224,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 156.844,
    cy: 166.568,
    r: 6.848
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 157.556,
    cy: 179.048,
    r: 6.848
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 158.204,
    cy: 190.864,
    r: 6.232
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 161.324,
    cy: 202.432,
    r: 6.232
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 164.388,
    cy: 213.384,
    r: 6.232
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 167.38,
    cy: 223.72,
    r: 6.224
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 171.004,
    cy: 233.984,
    r: 6.232
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 174.532,
    cy: 243.608,
    r: 6.224
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 179.004,
    cy: 253.488,
    r: 5.928
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.0736 -0.9973 0.9973 -0.0736 -64.1517 463.9608)",
    style: {
      fill: "#00233F"
    },
    cx: 183.415,
    cy: 261.776,
    rx: 6.216,
    ry: 5.944
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M191.628,271.12c0.248,3.424-2.208,6.392-5.488,6.64c-3.256,0.224-6.136-2.36-6.36-5.768 c-0.264-3.432,2.2-6.392,5.472-6.632C188.524,265.128,191.38,267.696,191.628,271.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M190.116,280.632c-0.088,3.432-2.832,6.152-6.104,6.088c-3.264-0.104-5.888-2.944-5.792-6.368 c0.088-3.432,2.824-6.144,6.08-6.064C187.596,274.376,190.188,277.208,190.116,280.632z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 330.844,
    cy: 122.808,
    r: 10.592
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 336.884,
    cy: 139.368,
    r: 9.04
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 340.124,
    cy: 153.224,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 341.796,
    cy: 166.568,
    r: 6.856
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 341.084,
    cy: 179.048,
    r: 6.848
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 340.444,
    cy: 190.864,
    r: 6.232
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 337.316,
    cy: 202.432,
    r: 6.232
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 334.252,
    cy: 213.384,
    r: 6.24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 331.244,
    cy: 223.72,
    r: 6.224
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 327.652,
    cy: 233.984,
    r: 6.232
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 324.124,
    cy: 243.608,
    r: 6.232
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 319.596,
    cy: 253.488,
    r: 5.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.0736 0.9973 -0.9973 -0.0736 599.4685 -33.3625)",
    style: {
      fill: "#00233F"
    },
    cx: 315.23,
    cy: 261.748,
    rx: 6.216,
    ry: 5.944
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.0736 0.9973 -0.9973 -0.0736 606.7755 -20.5902)",
    style: {
      fill: "#00233F"
    },
    cx: 312.951,
    cy: 271.528,
    rx: 6.216,
    ry: 5.944
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M308.54,280.632c0.08,3.432,2.832,6.152,6.096,6.088c3.256-0.104,5.888-2.944,5.792-6.368 c-0.088-3.432-2.824-6.144-6.088-6.064C311.052,274.376,308.46,277.208,308.54,280.632z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJew);
export default __webpack_public_path__ + "static/media/jew.628aa01f9fa530ef82ec54d47bb240f7.svg";
export { ForwardRef as ReactComponent };